import { BillingScreenContent } from "../../features/payment";

function BillingScreen() {
  return (
    <section className="payPage-section" id="Csection" tabIndex="-1">
      <div className="container">
        <BillingScreenContent />
      </div>
    </section>
  );
}

export default BillingScreen;
